import axios from 'axios'
import { missionApiUrl } from '../config/config'
import { PAGE_SIZE } from '../config/constant'
import { updateDataModel } from './models/updateDataModel'
import { Asset } from 'src/redux/reducers/assets'

export async function getLatestActiveSessionId(usecase_id: number) {
    try {
        const result = await axios.get(`${missionApiUrl}/sessions/usecase/${usecase_id}/active`)
        if (result) {
            return result.data?.data?.session_id
        }
    } catch (error) {
        console.log(`Error trying to get latest active session id: ${error}. Items will not update!`)
    }
}

export async function getMissionEntities(session_id: number) {
    let result = await axios(`${missionApiUrl}/sessions/${session_id}/entities`)

    if (result?.data?.entities.length > 0) {
        await updateDataModel.validate(result.data)
        return result.data.entities
    }

    return undefined
}

export async function setThreatLevel(session_id: number, entity_id: number, threat_level: number) {
    let success = false
    try {
        await axios.post(`${missionApiUrl}/sessions/${session_id}/entity/${entity_id}`, JSON.stringify({ threat_level: threat_level }), {
            headers: {
                'Content-Type': 'text/plain',
            },
        })

        success = true
    } catch (error) {
        console.log(error)
    }

    return success
}

export function addLogEvent(session_id: number, log_event: string) {
    axios.post(`${missionApiUrl}/sessions/${session_id}/add_log_event`, JSON.stringify({ log_event: log_event }), {
        headers: {
            'Content-Type': 'text/plain',
        },
    })
}

export async function createMissionEntity(sessionId: number, entity: Asset) {
    let success = false
    try {
        await axios.post(
            `${missionApiUrl}/sessions/${sessionId}/entities`,
            JSON.stringify({ entities: [mapToEntity(sessionId, entity)] }),
            {
                headers: {
                    'Content-Type': 'text/plain',
                },
            },
        )

        success = true
    } catch (error) {
        console.log(error)
    }

    return success
}

function mapToEntity(sessionId: number, entity: Asset) {
    return {
        session_id: sessionId + '',
        // TODO Session Episode
        session_episode: '1',
        name: entity.name,
        alliance: entity.alliance,
        type: entity.type,
        latitude: entity.latitude,
        longitude: entity.longitude,
        altitude: entity.altitude,
        velocity: entity.velocity,
        yaw: entity.yaw,
        pitch: entity.pitch,
        roll: entity.roll,
        payloads: entity.payload,
        threat_level: entity['threat_level'],
        threat_level_accuracy: 1,
    }
}

export async function getMissionEntitiesByQuery({ query = '', params = {} }) {
    const entities = axios.get(`${missionApiUrl}/entities`, {
        params: {
            limit: PAGE_SIZE,
            sort: '-createdAt',
            ...params,
            q: query,
        },
    })

    console.log(entities)

    return Promise.all([
        { id: '001', name: 'UAV-1' },
        { id: '002', name: 'UAV-2' },
    ])
}
